import { Injectable, inject } from '@angular/core';
import { Observable, ignoreElements } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Food } from '../interfaces/food';
import { StorageService } from './storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FoodService {
  FOOD_apiUrl = environment.apiUrl + '/food';

  constructor(
    private storageService: StorageService,
    private http: HttpClient
  ) {}

  //Food CRUD

  createFood(food: Food): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<void>(
      this.FOOD_apiUrl,
      { ...food },
      { headers: httpHeaders }
    );
  }

  getAllFoods(): Observable<Food[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Food[]>(this.FOOD_apiUrl, { headers: httpHeaders });
  }

  updateFood(food: Food): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.put<void>(
      this.FOOD_apiUrl,
      { ...food },
      { headers: httpHeaders }
    );
  }

  deleteFood(foodId: number): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.delete<void>(`${this.FOOD_apiUrl}/${foodId}`, {
      headers: httpHeaders,
    });
  }
}
